import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";

export const AddUserModal = ({ onClose, isOpen }) => {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    assignedRole: "Admin",
    status: "Active",
  });

  const [showActive, setShowActive] = useState(true);

  const roleOptions = [
    "Admin",
    "Section Head",
    "Supervisor",
    "School Head",
    "Teacher",
    "Student",
    "Content Manager",
  ];

  const handleInputChange = (field, value) => {
    setUserData((prev) => ({ ...prev, [field]: value }));
  };

  const handleToggleChange = (checked) => {
    setShowActive(checked);
    setUserData((prev) => ({
      ...prev,
      status: checked ? "Active" : "Inactive",
    }));
  };

  const handleSubmit = () => {
    // Here you would handle creating the user
    console.log("Creating new user:", userData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-[450px] p-6 gap-4 flex flex-col">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold text-[#FF9348]">Add User</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-black">
            <IoMdClose size={24} />
          </button>
        </div>

        <div>
          <p className="font-medium">
            Name<span className="text-red-500">*</span>
          </p>
          <input
            type="text"
            value={userData.name}
            onChange={(e) => handleInputChange("name", e.target.value)}
            placeholder="Enter User Name"
            className="w-full border border-gray-400 rounded-md px-2 py-2"
          />
        </div>

        <div>
          <p className="font-medium">
            Email<span className="text-red-500">*</span>
          </p>
          <input
            type="email"
            value={userData.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            placeholder="Enter Email Address"
            className="w-full border border-gray-400 rounded-md px-2 py-2"
          />
        </div>

        <div>
          <p className="font-medium">
            Assigned Role<span className="text-red-500">*</span>
          </p>
          <select
            value={userData.assignedRole}
            onChange={(e) => handleInputChange("assignedRole", e.target.value)}
            className="w-full border border-gray-400 rounded-md px-2 py-2"
          >
            {roleOptions.map((role) => (
              <option key={role} value={role}>
                {role}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-row justify-between items-center font-medium">
          <p>User Status</p>
          <div className="flex items-center gap-2">
            <span
              className={`text-sm font-medium ${
                showActive ? "text-blue-600" : ""
              }`}
            >
              {showActive ? "Active" : "Inactive"}
            </span>
            <label className="relative inline-flex items-center justify-between cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={showActive}
                onChange={(e) => handleToggleChange(e.target.checked)}
              />
              <div
                className="relative w-9 h-5 bg-gray-200 rounded-full peer 
                after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:right-[2px] 
                after:bg-white after:rounded-full after:h-4 after:w-4
                after:transition-all peer-checked:bg-blue-600 
                peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full"
              ></div>
            </label>
          </div>
        </div>

        <div className="flex flex-row items-center gap-4 w-full mt-4">
          <button
            onClick={onClose}
            className="w-1/2 py-2 border border-gray-300 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="flex flex-row items-center justify-center gap-2 text-white bg-blue-600 w-1/2 py-2 border border-gray-300 rounded-md"
          >
            Create User
          </button>
        </div>
      </div>
    </div>
  );
};
